import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../cn';
import styles from './Badge.module.css';

export type BadgeVariant =
  | 'default' | 'solid' | 'outline'
  | 'success' | 'warning' | 'danger' | 'info'
  | 'mcp';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  dot?: boolean;
  icon?: ReactNode;
}

export function Badge({ variant = 'default', dot, icon, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cn(styles.badge, styles[`v-${variant}`], className)} {...rest}>
      {dot && <span className={styles.dot} aria-hidden />}
      {icon}
      {children}
    </span>
  );
}
